import React from "react";

const DonationQuote = () => {
  return (
    <section className="bg-green-50 py-20 px-6 text-center">

      <blockquote className="max-w-5xl mx-auto text-lg md:text-xl text-green-700 italic leading-relaxed">
        <p className="mb-4">
          In many ways, is a very punya-giving thing is to donate or to be generous.
        </p>
        <p className="mb-4">
          Actually I enjoy My generosity more than anything else, and this generosity must be enjoyed
          thoroughly, otherwise we are not doing the dharma of our Lakshmi Tattwa.
        </p>
        <p className="mb-4">
          So to be generous, to be friendly, to use matter to give to others, is such a beautiful thing;
          and that gives such a beautiful personality to you – so much love, little little things you know sometimes.
        </p>
        <footer className="mt-8">
          <p className="text-green-800 font-semibold italic">Shri Mataji Nirmala Devi</p>
          <p className="text-gray-500 mt-1">Devi Puja, 17 December 1988</p>
        </footer>
      </blockquote>
    </section>
  );
};

export default DonationQuote;
